"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-pietro-in-cariano": {
    "34577281": [{
      "hkey": "9d221d3d",
      "slug": "corrubbio-cengia-castelrotto",
      "name": "Corrubbio-Cengia-Castelrotto",
      "primary": true,
      "skipSearch": false
    }],
    "corrubio": [{
      "hkey": "9d221d3d",
      "slug": "corrubbio-cengia-castelrotto",
      "name": "Corrubbio-Cengia-Castelrotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b68b5e18": [{
      "hkey": "0525211d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "casa-rossa": [{
      "hkey": "0525211d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-pietro-in-cariano"
    }],
    "26be6b04": [{
      "hkey": "9d221d3d",
      "slug": "corrubbio-cengia-castelrotto",
      "name": "Corrubbio-Cengia-Castelrotto",
      "primary": true,
      "skipSearch": false
    }],
    "castelrotto": [{
      "hkey": "9d221d3d",
      "slug": "corrubbio-cengia-castelrotto",
      "name": "Corrubbio-Cengia-Castelrotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-pietro-in-cariano"
    }],
    "62915e1d": [{
      "hkey": "9d221d3d",
      "slug": "corrubbio-cengia-castelrotto",
      "name": "Corrubbio-Cengia-Castelrotto",
      "primary": true,
      "skipSearch": false
    }],
    "castelrotto-cengia": [{
      "hkey": "9d221d3d",
      "slug": "corrubbio-cengia-castelrotto",
      "name": "Corrubbio-Cengia-Castelrotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-pietro-in-cariano"
    }],
    "6b465160": [{
      "hkey": "9d221d3d",
      "slug": "corrubbio-cengia-castelrotto",
      "name": "Corrubbio-Cengia-Castelrotto",
      "primary": true,
      "skipSearch": false
    }],
    "corrubbio": [{
      "hkey": "9d221d3d",
      "slug": "corrubbio-cengia-castelrotto",
      "name": "Corrubbio-Cengia-Castelrotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;